import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { SignatureRequestStatusBadgeComponent } from '../../components/signature-request-status-badge/signature-request-status-badge.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { SignatureRequestsService } from '../../signature-requests.service';
import { SignatureRequestMinimalViewModel } from '../../models/signature-request.viewmodel';
import { Observable, map } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

interface SignatureRequestListConfigurationViewModel{
  currentPage: number; 
  pageSize: number;
  status: number | null;
  length: number;
}


@Component({
  selector: 'app-signature-request-list-page',
  standalone: true,
  imports: [
    MatTableModule, 
    MatPaginatorModule, 
    MatSortModule, 
    CommonModule, 
    SignatureRequestStatusBadgeComponent, 
    RouterModule],
  providers: [SignatureRequestsService],
  templateUrl: './signature-request-list-page.component.html',
  styleUrls: ['./signature-request-list-page.component.scss']
})
export class SignatureRequestListPageComponent implements OnInit, AfterViewInit {

  public configuration: SignatureRequestListConfigurationViewModel;

  public signatureRequests$: Observable<SignatureRequestMinimalViewModel[]>;
  public totalItems$: Observable<number>;

  public dataSource: MatTableDataSource<SignatureRequestMinimalViewModel>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);


  constructor(private signatureRequestService: SignatureRequestsService){
    this.configuration = {
      currentPage: 1, 
      pageSize: 10,
      status: null,
      length: 0
    };
  }

  ngOnInit(): void {
    this.fetchSignatureRequests();
  }

  ngAfterViewInit(): void {
  
  }

  private fetchSignatureRequests(): void {
    const result$ = this.signatureRequestService.getSignatureRequests({
      page: Number(this.configuration.currentPage),
      pageSize: this.configuration.pageSize,
      status: this.configuration.status
    });

    this.signatureRequests$ = result$.pipe(map(result => result.signatureRequests));
    this.totalItems$ = result$.pipe(map(result => result.totalItems));
  }

  /**
   * 
   * @param event The page event containing the new page index and page size.
   */
  onPageChange(event: PageEvent): void {
    this.configuration = {
      ...this.configuration,
      currentPage: event.pageIndex + 1,
      pageSize: event.pageSize
    }
    this.fetchSignatureRequests();
  }
}
